import arcService from '@/services/arc-api-dynamic.service'
import * as plansService from '@/services/plans-api.service'
import { getFieldsByForm } from '@/utils'
import vuei18n from '@/plugins/vue-i18n';
import { config } from '@/plugins/env.config'
import {
  AUTHORIZATION_LOAD_ERROR,
  AUTHORIZATION_LOAD_SUCCESS,
  AUTHORIZATION_LOADING,
  AUTHORIZATION_COMMENT_LOADING,
  AUTHORIZATION_FORM_LOAD_SUCCESS,
  SET_CURRENT_FORM,
  SET_CURRENT_STEP,
  SET_ERROR,
  ADD_FILES,
  SET_STEP_ERROR,
  SET_BENEFICIARY,
  SET_BENEFICIARY_ERROR,
  SET_INPUTS,
  RESET_AUTHORIZATION_STATE,
  SET_REIMBURSEMENT_STATUS,
  SET_CLAIM_TYPE,
  SET_LIST_AUTHORIZATION,
  SET_AUTHORIZATION,
  SET_AUTHORIZATION_ERROR,
  SET_SPONSOR_SLUG,
  SET_IS_REIMBURSEMENT,
  SET_AUTHORIZATION_CREATED
} from '../mutation-types'
import router from '@/router'
import { camelizeKeys, decamelizeKeys } from 'humps';

const getAuthorizations = async ({ commit }, filters) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    const response = await arcService.getAuthorizationList(filters);
    let camelizeResponse = camelizeKeys(response.data);

    if(filters.orderBy === "coverageType"){
      camelizeResponse.content.sort((a,b)=> {

        let valueA = vuei18n.t(arcService.getType(a[filters.orderBy]));
        let valueB = vuei18n.t(arcService.getType(b[filters.orderBy]));

        if(filters.sort === "ASC"){
          return valueA > valueB ? 1 : valueA < valueB ? -1 : 0
        }
        if (filters.sort === "DESC"){
          return valueB > valueA ? 1 : valueB < valueA ? -1 : 0
        }

      });
    }

    commit(AUTHORIZATION_LOAD_SUCCESS, camelizeResponse)
    commit(AUTHORIZATION_LOADING, false)
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const getAuthorizationsForm = async ({ commit, state }) => {
  try {
    const response = await arcService.getAuthorizationForm(state.sponsorSlug);
    const data = camelizeKeys(response.data)

    const authenticatedForms = data.filter(form => !form.formSlug.includes('guest'))
    const formFields = getFieldsByForm(authenticatedForms)
    const formFieldsKeys = Object.keys(formFields)
    if (formFieldsKeys.length === 1 ) {
      formFields[formFieldsKeys[0]].shift()
      commit(SET_CURRENT_FORM, formFieldsKeys[0])
    }
    commit(AUTHORIZATION_FORM_LOAD_SUCCESS, { response: data, formsByStep: formFields })
    commit(AUTHORIZATION_LOADING, false)
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const getGuestAuthorizationsForm = async ({ commit, state }) => {
  try {
    const response = await arcService.getGuestAuthorizationForm(state.sponsorSlug);
    const data = camelizeKeys(response.data)

    const guestForms = data.filter(form => form.formSlug.includes('guest'))
    const formFields = getFieldsByForm(guestForms)
    const formFieldsKeys = Object.keys(formFields)
    if (formFieldsKeys.length === 1 ) {
      formFields[formFieldsKeys[0]].shift()
      commit(SET_CURRENT_FORM, formFieldsKeys[0])
    }
    commit(AUTHORIZATION_FORM_LOAD_SUCCESS, { response: data, formsByStep: formFields })
    commit(AUTHORIZATION_LOADING, false)
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const getBeneficiary = async ({ commit, rootState }) => {
  try {
    const beneficiaryId = rootState.auth.tokenExtensions.beneficiaryId;
    const sponsorResponse = await plansService.getBeneficiary(beneficiaryId);
    const beneficiary = camelizeKeys(sponsorResponse.data)
    commit(SET_BENEFICIARY, beneficiary)
    commit(SET_SPONSOR_SLUG, beneficiary.sponsorSlug)
    sessionStorage.setItem('sponsorSlug', beneficiary.sponsorSlug)
  } catch(error) {
    commit(SET_BENEFICIARY_ERROR, error)
  }
}

const setCurrentForm = ({ commit }, payload) => {
  commit(SET_CURRENT_FORM, payload)
}

const setCurrentStep = ({ commit }, payload) => {
  commit(SET_CURRENT_STEP, payload)
}

const nextStep = ({ commit, state, dispatch, getters, rootState }, payload) => {
  dispatch('setError',{hasError: false, error: null})
  if (state.currentStep === payload) {
    const { authorizationForms, currentForm } = getters;
    const form = authorizationForms.find(form => form.formSlug === currentForm)
    if (form && !form.reimbursement) {
      dispatch('sendAuthorization')
    } else {
      if (rootState.auth.guest == true) {
        dispatch('sendGuestReimbursement')  
      } else {
        dispatch('sendReimbursement')
      }      
    }
    
  } else {
    commit(SET_CURRENT_STEP, state.currentStep + 1)
  }
}

const lastStep = ({ commit, state, dispatch }) => {
  if (state.currentStep === 1) {
    dispatch('resetAuthorizationState')
    router.push('/home')
  } else {
    commit(SET_CURRENT_STEP, state.currentStep - 1)
    dispatch('setStepError',true);
    dispatch('setError',{hasError: false, error: null})
  }
}

const sendReimbursement = async ({ commit, state, rootState, dispatch }) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    const beneficiaryId = rootState.auth.tokenExtensions.beneficiaryId;
    const request = decamelizeKeys({ beneficiaryId, formSlug: state.currentForm, inputs: state.inputs })
    const response = await arcService.sendReimbursement(request)
    const reimbursement = camelizeKeys(response.data)
    dispatch('sendReimbursementFiles', reimbursement.reimbursementId)
  } catch (error) {
    const response = error.response
    if (response) {
      let errorMessage = null
      const status = response.status
      if (status === 422) {
        const exceptionData = response.data
        if (exceptionData.errors) {
          if (exceptionData.errors.length > 0) {
            errorMessage = exceptionData.errors[0].message;
          } 
        }
      }
      
      dispatch('setError',{hasError: true, error: errorMessage})
    }
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const sendGuestReimbursement = async ({ commit, state, dispatch }) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    const beneficiaryId = config.beneficiaryId;
    const inputs = state.inputs.filter(input => !input.slug.includes('doctor'))
    const providerEmailAddress = state.inputs.find(input => input.slug === 'doctor_email_address').value || null
    const doctorName = state.inputs.find(input => input.slug === 'doctor_name').value || null
    const doctorMedicalLicenseNumber = state.inputs.find(input => input.slug === 'doctor_medical_license').value || null
    const doctorCountryCode = 'MX'
    const request = decamelizeKeys({ beneficiaryId, formSlug: state.currentForm, inputs , providerEmailAddress, doctorName, doctorMedicalLicenseNumber, doctorCountryCode })
    const response = await arcService.sendGuestReimbursement(request)
    const reimbursement = camelizeKeys(response.data)
    dispatch('sendGuestReimbursementFiles', reimbursement)
  } catch (error) {
    const response = error.response
    if (response) {
      let errorMessage = null
      const status = response.status
      if (status === 422) {
        const exceptionData = response.data
        if (exceptionData.errors) {
          if (exceptionData.errors.length > 0) {
            errorMessage = exceptionData.errors[0].message;
          } 
        }
      }
      
      dispatch('setError',{hasError: true, error: errorMessage})
    }
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const sendReimbursementFiles = async ({ commit, state, dispatch }, reimbursementId) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    const filesByField = state.files;

    for (let i = 0; i < filesByField.length; i++) {

      const fieldFile = filesByField[i];
      const files = fieldFile.files;
      for (let j = 0; j < files.length; j++) {
        const file = files[j];
        await arcService.sendFile(fieldFile.fieldSlug, file, reimbursementId);
      }
    }
    dispatch('completeReimbursement', reimbursementId)
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    dispatch('setReimbursementToErrorStatus', reimbursementId)
  }
}

const sendGuestReimbursementFiles = async ({ commit, state, dispatch }, reimbursement) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    const filesByField = state.files;

    for (let i = 0; i < filesByField.length; i++) {

      const fieldFile = filesByField[i];
      const files = fieldFile.files;
      for (let j = 0; j < files.length; j++) {
        const file = files[j];
        await arcService.sendGuestFile(fieldFile.fieldSlug, file, reimbursement.reimbursementId);
      }
    }
    dispatch('completeGuestReimbursement', reimbursement)
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    dispatch('setGuestReimbursementToErrorStatus', reimbursement.reimbursementId)
  }
}

const setReimbursementToErrorStatus = async ({commit, dispatch}, reimbursementId) => {
  commit(AUTHORIZATION_LOADING, true)
  try{
    await arcService.setReimbursementToErrorStatus(reimbursementId);
    commit(SET_CURRENT_STEP, 1)    
    commit(RESET_AUTHORIZATION_STATE)    
    dispatch('setReimbursementStatus', 'ERROR')
    router.push('/home')
  }catch(error){
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const setGuestReimbursementToErrorStatus = async ({commit, dispatch}, reimbursementId) => {
  commit(AUTHORIZATION_LOADING, true)
  try{
    await arcService.setGuestReimbursementToErrorStatus(reimbursementId);
    commit(SET_CURRENT_STEP, 1)    
    commit(RESET_AUTHORIZATION_STATE)    
    dispatch('setReimbursementStatus', 'ERROR')
    router.push('/home')
  }catch(error){
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const completeReimbursement = async ({ commit, dispatch }, reimbursementId) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    await arcService.completeReimbursement(reimbursementId)
    commit(SET_CURRENT_STEP, 1)    
    commit(AUTHORIZATION_LOADING, false)
    commit(RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'SUCCESS')
    router.push('/home')
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const completeGuestReimbursement = async ({ commit, dispatch }, reimbursement) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    await arcService.completeGuestReimbursement(reimbursement.reimbursementId)
    commit(SET_CURRENT_STEP, 1)    
    commit(AUTHORIZATION_LOADING, false)
    commit(RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'SUCCESS')
    dispatch('setAuthorizationCreated', reimbursement.authorizationCode)
    router.push('/login')
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const sendAuthorization = async ({ commit, state, rootState, dispatch }) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    const beneficiaryId = rootState.auth.tokenExtensions.beneficiaryId;
    const request = decamelizeKeys({ beneficiaryId, formSlug: state.currentForm, inputs: state.inputs })
    const response = await arcService.sendAuthorization(request)
    const authorization = camelizeKeys(response.data)
    dispatch('sendAuthorizationFiles', authorization.id)
  } catch(error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const sendAuthorizationFiles = async ({ commit, state, dispatch }, authorizationId) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    const filesByField = state.files;

    for (let i = 0; i < filesByField.length; i++) {

      const fieldFile = filesByField[i];
      const files = fieldFile.files;
      for (let j = 0; j < files.length; j++) {
        const file = files[j];
        await arcService.sendAuthorizationFile(fieldFile.fieldSlug, file, authorizationId);
      }
    }
    dispatch('completeAuthorization', authorizationId)
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    dispatch('setAuthorizationToErrorStatus', authorizationId)    
  }
}

const setAuthorizationToErrorStatus = async ({commit, dispatch}, authorizationId) => {
  commit(AUTHORIZATION_LOADING, true)
  try{
    await arcService.setAuthorizationToErrorStatus(authorizationId);
    commit(SET_CURRENT_STEP, 1)    
    commit(RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'ERROR')
    router.push('/home')
  }catch(error){
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const completeAuthorization = async ({ commit, dispatch }, authorizationId) => {
  commit(AUTHORIZATION_LOADING, true)
  try {
    await arcService.completeAuthorization(authorizationId)
    commit(SET_CURRENT_STEP, 1)    
    commit(AUTHORIZATION_LOADING, false)
    commit(RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'SUCCESS')
    router.push('/home')
  } catch (error) {
    commit(AUTHORIZATION_LOAD_ERROR)
    commit(AUTHORIZATION_LOADING, false)
  }
}

const setError = ({ commit }, payload) => {
  commit(SET_ERROR, payload);
}

const setFiles = ({ commit }, payload) => {
  commit(ADD_FILES, payload)
}

const setStepError = ({ commit }, payload) => {
  commit(SET_STEP_ERROR, payload)
}

const setInput = ({ commit }, payload) => {
  commit(SET_INPUTS, payload)
}

const setReimbursementStatus = ({ commit }, payload) => {
  commit(SET_REIMBURSEMENT_STATUS, payload)
}

const setClaimType = ({ commit }, payload) => {
  commit(SET_CLAIM_TYPE, payload)
}

const resetAuthorizationState = ({ commit }) => {
  commit(RESET_AUTHORIZATION_STATE)
}

const setSingleAuthorization = async ({ commit }, payload) => {
  sessionStorage.setItem('listAuthorization', JSON.stringify(payload))
  commit(SET_LIST_AUTHORIZATION, payload)
  commit(SET_AUTHORIZATION, {})
}

const getAuthorizationDetail = async ({ commit, rootState, dispatch, state }, payload) => {
  try {
    const beneficiaryId = rootState.auth.tokenExtensions.beneficiaryId;
    const { statusConfiguration, iconConfiguration, type } = state.listAuthorization || {}
    const authorizationResponse = await arcService.getAuthorization(beneficiaryId, payload)
    let authorization = camelizeKeys(authorizationResponse.data)
    authorization = 
    {
      ...authorization, 
      statusLabel: arcService.getStatus(authorization),
      statusConfiguration, iconConfiguration, type
    }
    sessionStorage.setItem('authorization', JSON.stringify(authorization))
    commit(SET_AUTHORIZATION, authorization)
    dispatch('setIsReimbursement', authorization.isReimbursement)
    if (!state.authorizationFormsAndSteps) {
      dispatch('getAuthorizationsForm')
    }    
  } catch(error) {
    commit(SET_AUTHORIZATION_ERROR, error)
    router.push('/home')
  }
}

const getGuestAuthorizationDetail = async ({ commit, dispatch, state }, payload) => {
  try {
    const { statusConfiguration, iconConfiguration, type } = state.listAuthorization || {}
    const authorizationResponse = await arcService.getGuestAuthorization(payload)
    let authorization = camelizeKeys(authorizationResponse.data)
    authorization = 
    {
      ...authorization, 
      statusLabel: arcService.getStatus(authorization),
      statusConfiguration, iconConfiguration, type
    }
    sessionStorage.setItem('authorization', JSON.stringify(authorization))
    commit(SET_AUTHORIZATION, authorization)
    dispatch('setIsReimbursement', authorization.isReimbursement)
  } catch(error) {
    commit(SET_AUTHORIZATION_ERROR, error)
    router.push('/login')
  }
}

const sendReimbursementFilesWithComment = async ({ commit, state, dispatch, getters }) => {
  commit(AUTHORIZATION_LOADING, true)
 
  const filesByField = state.files;

  for (let i = 0; i < filesByField.length; i++) {

    const fieldFile = filesByField[i];
    const files = fieldFile.files;
    for (let j = 0; j < files.length; j++) {
      const file = files[j];
      const { authorization } = getters;
      if (authorization.isReimbursement == null || authorization.isReimbursement) {
        await arcService.sendFile(fieldFile.fieldSlug, file, authorization.reimbursementId);
      } else {
        await arcService.sendAuthorizationFile(fieldFile.fieldSlug, file, authorization.authorizationId);
      }
      
      const comment =  vuei18n.t('authorizationDetail.observations.addOtherFileComment', { name: file.name })
      const payload = decamelizeKeys({ comment, privateComment: true, beneficiaryComment: true })

      dispatch('sendComment', payload)
    }
  }
  commit(AUTHORIZATION_LOADING, false)
}

const sendBeneficiaryComment = async ({ commit, state, dispatch}, payload) => {
  commit(AUTHORIZATION_COMMENT_LOADING, true)
  const comment = decamelizeKeys({ comment: payload, privateComment: false, beneficiaryComment: true })
  await dispatch('sendComment', comment);
  const authorizationCode = state.authorization.authorizationCode;
  await dispatch('getAuthorizationDetail', authorizationCode);
  commit(AUTHORIZATION_COMMENT_LOADING, false);
}

const sendComment = async ({ state }, payload) => {
  await arcService.sendComment(state.authorization.authorizationCode, payload)
}

const setIsReimbursement = ({ commit }, payload) => {
  commit(SET_IS_REIMBURSEMENT, payload)
}

const setSponsorSlug = ({ commit }, payload) => {
  commit(SET_SPONSOR_SLUG, payload)
  sessionStorage.setItem('sponsorSlug', payload)
}

const setAuthorizationCreated = ({ commit }, payload) => {
  commit(SET_AUTHORIZATION_CREATED, payload)
}

export default {
  getAuthorizations,
  getAuthorizationsForm,
  setCurrentForm,
  setCurrentStep,
  nextStep,
  setError,
  setFiles,
  setStepError,
  sendReimbursement,
  sendReimbursementFiles,
  getBeneficiary,
  setInput,
  setReimbursementStatus,
  setClaimType,
  resetAuthorizationState,
  lastStep,
  completeReimbursement,
  setSingleAuthorization,
  getAuthorizationDetail,
  sendComment,
  sendReimbursementFilesWithComment,
  sendBeneficiaryComment,
  sendAuthorization,
  sendAuthorizationFiles,
  completeAuthorization,
  setIsReimbursement,
  setAuthorizationToErrorStatus,
  setReimbursementToErrorStatus,
  setSponsorSlug,
  getGuestAuthorizationsForm,
  sendGuestReimbursement,
  sendGuestReimbursementFiles,
  setGuestReimbursementToErrorStatus,
  completeGuestReimbursement,
  getGuestAuthorizationDetail,
  setAuthorizationCreated
}